import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import ActiveImageSetVersions from './ActiveImageSetVersions';
import ReadingReactions from './ReadingReactions';
import UserAvatars from './UserAvatars';

const Misc = () => (
  <Switch>
    <Route path="/misc/active-image-set-versions" component={ActiveImageSetVersions} />
    <Route path="/misc/reading-reactions" component={ReadingReactions} />
    <Route path="/misc/user-avatars" component={UserAvatars} />
    <Redirect to="/misc/active-image-set-versions" />
  </Switch>
);

export default Misc;
